import moment from 'moment';
import { SuiteUserContact, SuiteUserRow } from './types';

export const toSuiteUserRow = (contact: SuiteUserContact): SuiteUserRow => {
  const roleName: string = contact.roles?.[0]?.role?.name || '';

  const lastLoggedOnFormatted: string = contact.lastLoggedOn
    ? moment(contact.lastLoggedOn).format('dddd MM/DD/YYYY')
    : 'Never';

  return {
    ...contact,
    roleName,
    lastLoggedOnFormatted,
  };
};
